import React from 'react';
import style from './Contact.module.css'
const Contact = () => {
    return (
        <div className={style.formContent}>
            <div className={style.layout}>
                <div className={style.infoPanel}>
                    <span className={style.infoEyebrow}>Estamos para ayudarte</span>
                    <h1 className={style.infoTitle}>Hablemos sobre tu próximo paso</h1>
                    <p className={style.infoText}>
                        Ya sea que tengas una consulta puntual o quieras conocer más sobre nuestros
                        servicios, un integrante de By Raíces va a leer tu mensaje y te va a responder
                        a la brevedad.
                    </p>

                    <div className={style.infoValues}>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>💬</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Respuesta personalizada</h3>
                                <p className={style.infoValueText}>Cada consulta es leída y respondida por una persona de nuestro equipo.</p>
                            </div>
                        </div>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>🏡</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Asesoramiento integral</h3>
                                <p className={style.infoValueText}>Te orientamos sobre compra, venta, alquiler o desarrollos según lo que necesites.</p>
                            </div>
                        </div>
                        <div className={style.infoValueItem}>
                            <span className={style.infoValueIcon}>⚖️</span>
                            <div>
                                <h3 className={style.infoValueTitle}>Respaldo profesional</h3>
                                <p className={style.infoValueText}>Todas las operaciones son intermediadas por corredores públicos matriculados.</p>
                            </div>
                        </div>
                    </div>
                </div>

             <div className={style.card}>
        <h2 className={style.title} >Envíenos un mensaje</h2>
        <p className={style.text}>Completá el formulario para contactarnos sobre cualquier pregunta o comentario que tengas y nos contactaremos a la brevedad.</p>

        <form className={style.mailForm} action="https://formsubmit.co/byraices@byraices.com" method="POST" >
           <label className={style.mailLabel} htmlFor="name">Nombre</label>
           <input className={style.inputText} type="text" name='name' id='name'/>

           <label className={style.mailLabel} htmlFor="email">Correo electronico</label>
           <input className={style.inputText} type="email" name='email' id='email' />

           <label className={style.mailLabel} htmlFor="email">Telefono</label>
           <input className={style.inputText} type="Text" name='Phone' id='Phone' />

           <label className={style.mailLabel} htmlFor="email">Direccion</label>
           <input className={style.inputText} type="Text" name='direction' id='direction' />

           <label className={style.mailLabel} htmlFor="subject">Asunto</label>
                <input className={style.inputText} type="text" name="subject" id="subject" />

           <label className={style.mailLabel} htmlFor="coments">Comentarios</label>
           <textarea className={style.inputText} name="coments" id="coments" cols="30" rows="5"></textarea>

           <input className={style.btn} type="submit" value="Enviar"/>
           <input type="hidden" name="_next" value="https://byraices.com/"/>
           <input type="hidden" name="_captcha" value="false"/>
           {/* poner la url correcta */}
        </form>
   </div>
            </div>
   </div>
    );
};

export default Contact;